import type { Product } from '../types/product';

const getUniqueRelatedUpsellIds = (products: Product[]): string[] => {
  const seen = new Set<string>();
  const uniqueIds: string[] = [];

  for (const product of products) {
    for (const upsell of product.upsellProducts ?? []) {
      if (upsell.upsellType === 'Related' && !seen.has(upsell.id)) {
        seen.add(upsell.id);
        uniqueIds.push(upsell.id);
      }
    }
  }

  return uniqueIds;
};

export default getUniqueRelatedUpsellIds;
